import { render } from "./EtatChiffreAffaireClient.vue?vue&type=template&id=5b8344c8&ts=true"
import script from "./EtatChiffreAffaireClient.vue?vue&type=script&lang=ts"
export * from "./EtatChiffreAffaireClient.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__